<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex :class="budgetHeader.id ? 'sm6' : 'sm12'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="false"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.required('Issue date')"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="budgetHeader.id">
                <v-text-field
                  label="Issue No"
                  name="issueNo"
                  type="text"
                  v-model="budgetHeader.issueNo"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="budgetHeader.financeSettingId"
                  :items="financeSettingList"
                  color="blue-grey lighten-2"
                  label="Choose Finance Setting..."
                  item-text="financialYearName"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.required('Finance Setting')"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="budgetHeader.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Choose Shop..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.required('Shop')"
                  :readonly="checkUserShop() ? true : false"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="budgetHeader.description"
                  type="text"
                  :rules="rules.lengthRules(500, 'Description')"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="budgetHeader.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="budgetHeader.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="budgetHeader.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="budgetHeader.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="budgetHeader.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="budgetHeader.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="showAccountListDialog = !showAccountListDialog"
                  >
                    ADD BUDGET ACCOUNT
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-card>
                  <v-data-table
                    :headers="headers"
                    :items="budgetHeader.budgetDetailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>
                        <v-text-field
                          v-model="props.item.accountCode"
                          type="text"
                          :rules="
                            rules.lengthRequiredRules(100, 'Account code')
                          "
                          readonly
                          style="width: 100px"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.accountName"
                          type="text"
                          readonly
                          style="width: 200px"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.accountType"
                          type="text"
                          readonly
                          style="width: 100px"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.parentAccountName"
                          type="text"
                          readonly
                          style="width: 200px"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.budgetAmount"
                          type="number"
                          :rules="rules.greaterZeroAmountRules('Budget amount')"
                          style="width: 200px"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.remark"
                          type="text"
                          :rules="rules.lengthRules(500, 'Remark')"
                          style="width: 200px"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-btn icon @click="removeAccount(props.item.id)">
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!--multi select account list dialog-->
    <multi-select-account-dialog
      :showDialog="showAccountListDialog"
      :params="{
        isParent: false,
        status: 'ACTIVE',
        accountheadId: '',
        type: '',
      }"
      @close="closeAccountDialog"
    ></multi-select-account-dialog>
  </v-container>
</template>
  
<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { BudgetFormRules } from "../../helpers/validation-rules";
import { budgetService } from "../../services/budget-service";
import { BudgetHeader, BudgetDetail } from "../../models/model";
import { shopService } from "../../services/shop-service";
import { financeSettingService } from "../../services/finance-setting-service";
import MultiSelectAccountDialog from "../dialogs/MultiSelectAccountDialog.vue";

export default {
  name: "BudgetDetail",
  components: { VSwitch, MultiSelectAccountDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    saveLoading: false,
    showAccountListDialog: false,
    breadcrumbs: [
      {
        text: "Budget",
        disabled: false,
        to: "budgets",
      },
      {
        text: "Budget Details",
        disabled: true,
      },
    ],
    headers: [
      { text: "Account Code", sortable: false },
      { text: "Account Name", sortable: false },
      { text: "Account Type", sortable: false },
      { text: "Parent Account Name", sortable: false },
      { text: "Budget Amount", sortable: false },
      { text: "Remark", sortable: false },
      { text: "Action", sortable: false },
    ],
    rules: new BudgetFormRules(),
    budgetHeader: new BudgetHeader(),
    budgetDetail: new BudgetDetail(),
    oldBudgetHeader: new BudgetHeader(),
    issueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    createdDate: "",
    updatedDate: "",
    responseError: "",
    shopList: [],
    financeSettingList: [],
  }),
  created() {
    this.getAllShop();
    this.getFinanceSettingList();
    this.budgetHeader.shopId = this.checkUserShop();

    const id = this.$route.params.id;
    if (id != "new") {
      this.getBudgetDetail(id);
    }
  },
  methods: {
    checkUserShop() {
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFinanceSettingList() {
      financeSettingService
        .getAllFinanceSetting()
        .then((res) => {
          this.financeSettingList = res.data.financeSettingDTOs;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail = this.budgetHeader.budgetDetailList.find(
          (d) => d.id == id
        );

        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },
    addBudgetDetail() {
      // deep copy
      let budgetDetail = JSON.parse(JSON.stringify(this.budgetDetail));
      // if no id, add temporary id for key
      if (!budgetDetail.id) {
        budgetDetail.isNew = true;
        budgetDetail.id = this.generateId();
      }
      return budgetDetail;
    },
    closeAccountDialog(selectedAccountList) {
      selectedAccountList.forEach((account) => {
        let budgetAccount = this.budgetHeader.budgetDetailList.find(
          (v) => v.accountId === account.id
        );
        if (typeof budgetAccount == "undefined") {
          let budgetDetail = this.addBudgetDetail();
          budgetDetail.accountId = account.id;
          budgetDetail.accountCode = account.code;
          budgetDetail.accountName = account.accName;
          budgetDetail.accountType = account.accountTypeName;
          if (account.accountParent) {
            budgetDetail.parentAccountName = account.accountParent.accName;
          }
          this.budgetHeader.budgetDetailList.unshift(budgetDetail);
        }
      });
      this.showAccountListDialog = !this.showAccountListDialog;
    },
    removeAccount(budgetDetailId) {
      const index = this.budgetHeader.budgetDetailList
        .map((d) => d.id)
        .indexOf(budgetDetailId);

      if (!this.budgetHeader.budgetDetailList[index].isNew) {
        if (!this.budgetHeader.deleteBudgetDetailIds) {
          this.budgetHeader.deleteBudgetDetailIds = [];
        }
        this.budgetHeader.deleteBudgetDetailIds.push(budgetDetailId);
      }
      this.$delete(this.budgetHeader.budgetDetailList, index);
    },
    getBudgetDetail(id) {
      budgetService.getBudgetDetail(id).then((res) => {
        this.budgetHeader = res.data;
        this.issueDate = commonService.millisecondToDate(
          this.budgetHeader.issueDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.createdDate = commonService.millisecondToDate(
          this.budgetHeader.createdDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.millisecondToDate(
          this.budgetHeader.updatedDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.oldBudget = JSON.parse(JSON.stringify(res.data));
      });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveBudget) {
          this.saveLoading = true;
          let budget = this.budgetHeader;
          budget.issueDateInMilliSeconds = commonService.convertToMilliseconds(
            this.issueDate
          );
          budget.budgetDetailList.forEach((budgetAccount) => {
            if (budgetAccount.isNew) budgetAccount.id = null;
          });
          budgetService
            .saveBudget(budget)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.budgetHeader.id) {
        this.budgetHeader = new BudgetHeader();
      } else {
        this.budgetHeader = JSON.parse(JSON.stringify(this.oldBudget));
      }
    },
    goBack() {
      this.$router.push("/budgets");
    },
  },
};
</script>
  